import { Component, OnInit,OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { BaseHttpService} from 'src/app/shared/services/basehttp.service'
import { Constants } from 'src/app/shared/constants';
import { CardService } from 'src/app/shared/components/view/card/card.service';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthorizationService} from 'src/app/shared/services/authorization.service';
import { LoginModel } from 'src/app/login/login.model';
import { GlobalsessionhandlerService } from 'src/app/shared/services/globalsessionhandler.service';
// import { RequestOptions } from '@angular/http';
// import { HttpHeaders, HttpParams } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { SurveyUrlService } from './survey-url.service';
import { DatePipe } from "@angular/common";


@Component({
  selector: 'app-survey-url',
  templateUrl: './survey-url.component.html',
  styleUrls: ['./survey-url.component.scss']
,  standalone: false
})
export class SurveyUrlComponent implements OnInit, OnDestroy {
  constant: Constants = new Constants();
  routeSurveyId: string;
  alreadyTaken : boolean = false;
  expiredSurvey:boolean=false;
  groupId : string;
  isLoginRequired: boolean ;
  multipleResponses: boolean;

  constructor(
    private baseHttpService: BaseHttpService,
    private router : Router,
    private cardservice: CardService,
    private datePipe:DatePipe,
    private route: ActivatedRoute,
    private authService : AuthService,
    private authorization : AuthorizationService,
    private cookieService : CookieService,
    private surveyUrlService : SurveyUrlService,
    private globalsessionhandler : GlobalsessionhandlerService
  ) {}

  ngOnInit() {
    
    this.routeSurveyId= this.route.snapshot.params['id'];
    this.groupId = this.route.snapshot.params['groupId'];

    this.globalsessionhandler.setAnonymousUser(true);

    if(this.routeSurveyId == "-99"){
        return;
    }

    const httpOptions = {
     // headers: new HttpHeaders({ 'AnonymousId': this.surveyUrlService.getToken() }),
      observe: 'response', withCredentials : true
    };

    this.baseHttpService
    .get(this.constant.GetSurveySettings+'/'+ this.routeSurveyId, httpOptions /* {observe: 'response', withCredentials : true} */ )
    .subscribe(result => { 
                          this.isLoginRequired= result.body.isLoginRequired;
                          if(result.body.isOverdueAccessAllowed==false)
                          {
                          if(result.body.dueDate && this.datePipe.transform(result.body.dueDate,'yyyy-MM-dd') < this.datePipe.transform( Date.now(),'yyyy-MM-dd'))
                          {
                              this.expiredSurvey=true;
                              return;
                          }
                          }
                          this.GetNextSteps();
                        },
                err => console.log(err),
                () => console.log("Complete")
                        );

    

  }

  GetNextSteps()
  {
    
    if(this.isLoginRequired == true)
    {
      return;
    }

    this.globalsessionhandler.setGroupId(this.groupId);

    if( this.surveyUrlService.getToken() != "")
    {

      const httpOptions = {
        observe: 'response', withCredentials : true
      };

      this.baseHttpService.get(this.constant.getExistingAnonymousResponse+'/'+this.routeSurveyId+'/'+this.groupId
      , httpOptions)
      .subscribe(result =>{
        
        if(result.body == true)
        {

        this.alreadyTaken = true;
        return;
        }
        else{

            this.takeSurvey(this.routeSurveyId) ;

          }
      });
    }
    else{ this.takeSurvey(this.routeSurveyId); }

  }
  takeSurvey(surveyId: string) {
    const httpOptions = {
      observe: 'response', withCredentials : true
    };
    this.baseHttpService
      .getById(this.constant.getSurveyById, surveyId,httpOptions )
      .subscribe(result => {
        if (result != null) {
          
          this.cardservice.getSurveyDetails(result.body);

          this.router.navigate(["/user/initiate-survey"]);
        }
      });
  }

  ngOnDestroy() {
    //This blank function is mandatory.
  }

}
